import { getStore } from "../../../api/services/storeService";
import { getTrackingOrder } from "../../../api/services/orderService.js";
import { getDiffMinsAccordingByStoreTimeZone } from "../../../api/helpers/datetimeZoneHelper";
import { getOrderStatus } from "../../../api/helpers/orderHelper";
import { mapMutations, mapActions } from "vuex";
import moment from "moment";
export default {
  methods: {
    ...mapMutations(["setStoreLoaded"]),
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    beforeDestroyComponent() {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
    },
    createdComponent() {
      var that = this;
      getStore(this.storeid)
        .get()
        .then(doc => {
          if (doc.exists) {
            that.store = doc.data();
          }
        })
        .catch(reason => {
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath
          ]);
          that.redirectToErrorPage();
        });
      //get order
      if (this.userid) {
        getTrackingOrder(this.userid, this.orderid).onSnapshot(
          doc => {
            if (doc.exists) {
              that.trackingOrder = doc.data();
              that.updateDisplayModel(that.trackingOrder);
            }
          },
          function(reason) {
            that.insertErrorlog([
              reason.name,
              reason.toString(),
              that.$router.currentRoute.fullPath
            ]);
            that.redirectToErrorPage();
          }
        );
      }
    },
    mountedComponent() {
      this.setStoreLoaded();
      this.minutes = getDiffMinsAccordingByStoreTimeZone(
        this.store,
        this.trackingOrder.ScheduledTime,
        moment()
      );
      var that = this;
      var checkRefreashPage = function() {
        that.minutes = getDiffMinsAccordingByStoreTimeZone(
          that.store,
          that.trackingOrder.ScheduledTime,
          moment()
        );
        if (that.minutes < 0) {
          clearInterval(that.timerId);
        }
      };
      this.timerId = setInterval(checkRefreashPage, 1000);
    },
    continueShopping() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.store.ID,
          storename: this.store.Name.split(" ").join("-")
        }
      });
    },
    viewHistory() {
      this.$router.push({
        name: "orderhistory",
        params: { storeid: this.store.ID, storename: this.store.Name }
      });
    },
    updateDisplayModel(order) {
      if (order.OrderType === 10 || order.OrderType === 2) {
        this.displayModel.orderMode = "Delivery";
        this.displayModel.finishState = "Order on its way!";
      } else {
        this.displayModel.orderMode = "Pickup";
        this.displayModel.finishState = "Ready for pickup!";
      }
      //update status
      this.displayModel.status = getOrderStatus(order);

      switch (this.displayModel.status) {
        case -1:
          this.displayModel.orderState = "Order Rejected";
          break;
        case 0:
          this.displayModel.orderState = "Order Sent";
          break;
        case 3:
          this.displayModel.orderState = "Order Submitted";
          break;
        case 1:
          this.displayModel.orderState = "Being Prepared";
          break;
        case 2:
          this.displayModel.orderState = "Ready";
          break;
      }
    },
    updateStatus(statusDesc) {
      this.displayModel.orderState = statusDesc;
    }
  }
};
